export class AusFindingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAusFindings({ manualSwitchAusType, loanId }) {
    return this.#http.get(`api/aus/status/${loanId}`, {
      params: {
        manualSwitchAusType,
      },
    });
  }

  async getAusSummary({ manualSwitchAusType, loanId, correlationId, verificationRequestType = 2 }) {
    const correlationIdPath = correlationId
      ? `?verificationRequestType=${verificationRequestType}&correlationId=${correlationId}`
      : '';

    return this.#http.get(`api/aus/summary/${loanId}${correlationIdPath}`, {
      params: {
        manualSwitchAusType,
      },
    });
  }

  async getAusFindingsList({ loanId, typeOfAus }) {
    return this.#http.get(`api/aus/findings/${loanId}/list/${typeOfAus}`);
  }
}
